export default {
  name: 'modal'
}
